<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <img class="sign_bg" src="@/assets/login_image.png" alt="" />

    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <!-- Sign In Form Column -->
      <a-col
        :span="24"
        :md="24"
        :lg="{ span: 16, offset: 0 }"
        :xl="{ span: 16, offset: 2 }"
        class="col-form"
      >
        <a-card
          :bordered="false"
          style="border-radius: 20px; padding: 20px 30px; margin-top: 18%"
        >
          <img class="content_bg" src="@/assets/login_bg.png" alt="" />
          <a-col
            :span="24"
            :md="24"
            :lg="{ span: 24, offset: 0 }"
            :xl="{ span: 12, offset: 2 }"
            class="col-form"
          >
            <a-card
              :bordered="false"
              style="
                border-radius: 20px;
                padding: 0 30px;
                background-color: #ffffff98;
              "
            >
              <div class="login_title_box mb-15">
                <h2>天马洞察</h2>
                <div class="title_tg">天马AI系列</div>
              </div>

              <a-form
                id="components-form-demo-normal-login"
                :form="form"
                class="login-form"
                @submit="handleSubmit"
                :hideRequiredMark="true"
              >
                <a-form-item class="mb-10" label="账号" :colon="false">
                  <a-input
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入账号!',
                          },
                        ],
                      },
                    ]"
                    placeholder="请输入账号!"
                  />
                </a-form-item>
                <a-form-item class="mb-5" label="密码" :colon="false">
                  <a-input
                    v-decorator="[
                      'password',
                      {
                        rules: [{ required: true, message: '请输入密码!' }],
                      },
                    ]"
                    type="password"
                    placeholder="请输入密码"
                  />
                </a-form-item>

                <a-form-item>
                  <a-button
                    type="primary"
                    block
                    html-type="submit"
                    class="login-form-button"
                  >
                    登录
                  </a-button>
                </a-form-item>
              </a-form>
            </a-card>
            <!-- / Sign In Form -->

            <!-- <p class="font-semibold text-muted">
          Don't have an account?
          <router-link to="/sign-in" class="font-bold text-dark"
            >Sign Up</router-link
          >
        </p> -->
          </a-col>
        </a-card>
      </a-col>

      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
        <!-- <img src="images/img-signin.jpg" alt="" /> -->
      </a-col>
      <!-- Sign In Image Column -->
    </a-row>
    <!-- 演示遮罩方式 -->
    <div id="captcha-mask" v-show="showCaptchaMask">
      <div id="captcha-div"></div>
    </div>
  </div>
</template>

<script>
import storeRouter from "@/router/admin.js";
import { login } from "@/api/user.js";
import { message } from "ant-design-vue";
const VUE_APP_API_URL = process.env.VUE_APP_BASE_API || `${location.origin}`;

export default {
  data() {
    return {
      showCaptchaMask: false,
      // Binded model property for "Sign In Form" switch button for "Remember Me" .
      rememberMe: true,
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  created() {},
  mounted() {},
  methods: {
    // Handles input validation after submission.
    loginClick(data) {
      this.showCaptchaMask = true;
      const captchaConfig = {
        // 请求验证码接口
        requestCaptchaDataUrl: VUE_APP_API_URL + "/auth/c/generateCaptcha",
        // 验证验证码接口
        validCaptchaUrl:
          VUE_APP_API_URL +
          "/auth/c/verify?account=" +
          data.account +
          "&password=" +
          data.password,
        // 绑定的div
        bindEl: "#captcha-div",
        // 验证成功回调函数
        validSuccess: (res, c, t) => {
          console.log("验证码验证成功回调...",res);
          // 销毁验证码
          t.destroyWindow();
          this.showCaptchaMask = false;
          this.$store
            .dispatch("user/loginData", res.data)
            .then(() => {
              this.$store
                .dispatch("user/getInfo")
                .then((res) => {
                  if (res.auditStatus != 3) {
                    this.$router.push({
                      path: "/prepare",
                    });
                  } else {
                    this.$router.push({
                      path: "/",
                    });
                  }

                  this.loading = false;
                })
                .catch((err) => {
                  this.loading = false;
                });
            })
            .catch((err) => {
              this.showCaptchaMask = false;
              this.loading = false;
            });

          // alert("验证成功,token:" + res.data.token);
          // todo 携带token调用业务登录方法
        },
        validFail: (res,c,t) => {
          console.log(res)
          message.error(res.msg || "Error");
          this.showCaptchaMask = false;
        },
        btnCloseFun: () => {
          this.showCaptchaMask = false;
        },
      };

      window.initTAC("static/tac", captchaConfig).then((tac) => {
        tac.init();
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          console.log("Received values of form: ", values);
          return;
        }
        this.loginClick({
          account: values.email,
          password: values.password,
        });
      });
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}
.code_class {
  display: flex;
}
#captcha-mask {
  display: flex;
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.53);
  justify-content: center;
  align-items: center;
}
</style>
